import { SlideAdmin, Slide, Lab } from "pwapi";

import DateRange from "components/customInputs/DateRangeInput";
import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";

type SlidesFiltersProps = {
  slidesStatus: string;
  slidesStainName: string;
  slidesLab: string;
  slidesSlideReviewReason: string;
  slidesQcStatus: string;
  slidesScannedDateAfter: string;
  slidesScannedDateBefore: string;
  slidesExpectedUploadByAfter: string;
  slidesExpectedUploadByBefore: string;

  labs: Lab[];

  onChange: Function;
  onChangeDateRange: Function;
};

const SlidesFilters = (props: SlidesFiltersProps) => {
  return (
    <>
      <SelectInput
        id="slidesStatus"
        label="Slide Status"
        defaultLabel="All Statuses"
        options={Object.values(Slide.status).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.slidesStatus}
        onChange={(e: any) =>
          props.onChange("slidesStatus", e.target.value || "")
        }
      />
      <SelectInput
        id="slidesQcStatus"
        label="QC Status"
        defaultLabel="All Statuses"
        options={Object.values(SlideAdmin.qc_status).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.slidesQcStatus}
        onChange={(e: any) =>
          props.onChange("slidesQcStatus", e.target.value || "")
        }
      />
      <TextInput
        id="slidesStainName"
        value={props.slidesStainName}
        label="Stain"
        onChange={(e: any) =>
          props.onChange("slidesStainName", e.target.value || "")
        }
        onClear={() => props.onChange("slidesStainName", "")}
      />
      <SelectInput
        id="slidesLab"
        label="Scanning Lab"
        defaultLabel="All Labs"
        value={props.slidesLab}
        options={props.labs.map((v) => ({ label: v.name, value: `${v.id}` }))}
        onChange={(e: any) => props.onChange("slidesLab", e.target.value || "")}
      />
      <SelectInput
        id="slidesSlideReviewReason"
        label="Review Reason"
        defaultLabel="All Reasons"
        options={Object.values(SlideAdmin.slide_review_reason).map((v) => ({
          label: v,
          value: v,
        }))}
        value={props.slidesSlideReviewReason}
        onChange={(e: any) =>
          props.onChange("slidesSlideReviewReason", e.target.value || "")
        }
      />
      <DateRange
        id="slidesScannedDate"
        label="Scanned Date"
        values={{
          from: {
            id: "slidesScannedDateAfter",
            name: "slides_scanned_after",
            value: props.slidesScannedDateAfter,
          },
          to: {
            id: "slidesScannedDateBefore",
            name: "slides_scanned_before",
            value: props.slidesScannedDateBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
      <DateRange
        id="slidesExpectedUploadDate"
        label="Expected Upload Date"
        values={{
          from: {
            id: "slidesExpectedUploadByAfter",
            name: "slides_expected_upload_by_after",
            value: props.slidesExpectedUploadByAfter,
          },
          to: {
            id: "slidesExpectedUploadByBefore",
            name: "slides_expected_upload_by_before",
            value: props.slidesExpectedUploadByBefore,
          },
        }}
        onChangeDate={props.onChangeDateRange}
        isClearable
      />
    </>
  );
};

export default SlidesFilters;
